<template>
    <Form ref="form" @submit="onSubmit">
        <div class="modal-header">
            <h4 class="modal-title">
                {{ $getLocaleMessage('buttons', 'updating') }} Impuesto <strong>{{ getSelectedTax.name }}</strong>
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="card-body">
                <div class="form-group">
                    <label for="branchOfficeId">Matriz y/o Sucursales:</label>
                    <BranchOfficesSelect v-model="tax.branchOfficeId" :name="'branchOfficeId'" :options="branchOfficeOptions"></BranchOfficesSelect>                
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <label for="name">Nombre:</label>
                        <Field v-model="tax.name" type="text" class="form-control" name="name" placeholder="Nombre"
                            rules="required" />
                        <ErrorMessage name="name" class="input-error"></ErrorMessage>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <label for="description">Descripción:</label>
                        <Field v-model="tax.description" type="text" class="form-control" name="description"
                            rules="required" />
                        <ErrorMessage name="description" class="input-error"></ErrorMessage>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <label for="value">Valor:</label>
                        <Field v-model="tax.value" type="number" class="form-control" name="value" :rules="isNumeric"/>
                        <ErrorMessage name="value" class="input-error"></ErrorMessage>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <label for="remarks">Observaciones:</label>
                        <Field as="textarea" v-model="tax.remarks" type="text" class="form-control" name="remarks"
                            placeholder="Observaciones" />
                        <ErrorMessage name="remarks" class="input-error"></ErrorMessage>
                    </div>
                </div>
                <div class="form-group">
                    <label for="statusId">Estatus:</label>
                    <StatusSelect v-model="tax.statusId" :name="'statusId'" :options="statusOptions"></StatusSelect>                
                </div>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $getLocaleMessage('buttons', 'cancel') }}</button>
            <PrimaryButton class="btn btn-primary" type="submit">
                {{ $getLocaleMessage('buttons', 'update') }}
            </PrimaryButton>
        </div>
    </Form>
</template>

<script>
import * as helper from '@/helpers';
import Tax from '@/Models/Tax';

import { mapState, mapActions } from 'pinia';
import { useTaxesStore } from '@/pinia/taxes.module';
import { useBranchOfficesStore } from '@/pinia/branchOffices.module';
import { useStatusStore } from '@/pinia/status.module';

import PrimaryButton from '@/Components/PrimaryButton.vue';
import BranchOfficesSelect from '@/Components/Selects/SelectField.vue';
import StatusSelect from '@/Components/Selects/SelectField.vue';

export default {
    components: {
        PrimaryButton,
        BranchOfficesSelect,
        StatusSelect,
    },
    mixins: [],
    data() {
        return {
            tax: new Tax(),
        }
    },
    props: {
        selectedRecord: {
            type: Tax,
            default: () => {}
        },
    },
    emits: ['close-modal'],
    computed: {
        ...mapState(useTaxesStore, ['getSelectedTax']),
        ...mapState(useBranchOfficesStore, ['getActiveBranchOffices']),
        ...mapState(useStatusStore, ['getAllStatusByType']),
        branchOfficeOptions() {
            return helper.mapOptions(this.getActiveBranchOffices);
        },
        statusOptions() {
            return helper.mapOptions(this.getAllStatusByType(1));
        },
    },
    methods: {
        ...mapActions(useTaxesStore, ['setSelectedTax', 'updateTax']),
        ...mapActions(useBranchOfficesStore, ['fetchBranchOffices', 'setSelectedBranchOffice']),
        ...mapActions(useStatusStore, ['fetchStatus', 'setSelectedStatus']),
        onSubmit() {
            this.updateTax(this.tax);
            this.$refs.form.resetForm();
            this.closeModal();
        },
        closeModal() {
            this.$emit('close-modal', true);
        },
        setNewBranchOffice(id) {
            this.tax.branchOfficeId = id;
            this.setSelectedBranchOffice(id);
        },
        setNewStatus(id) {
            this.tax.statusId = id;
            this.setSelectedStatus(id);
        },
        // Custom vee-validate rules:
        isNumeric(value) {
            if(typeof(value) !== "undefined" && typeof(value) !== "number") {
                return 'El campo debe ser un número válido';
            } else if(typeof(value) !== "undefined" && typeof(value) === "number") {
                return true;
            } else {
                return 'El campo es obligatorio';
            }
        },
    },
    watch: {
        selectedRecord: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.tax = newValue;
                }
            }
        }
    },
    created() {
        this.setSelectedTax(this.selectedRecord.id);
    }
}
</script>
